import { ELLIPSIS } from '../constants';
import { showError } from '../toast';

const POPUP_WIDTH = 900;
const POPUP_HEIGHT = 700;

/* Открывает всплывающее окно (popup) после асинхронного действия, возвращает ссылку на него */
export async function windowOpenWithPrefetch(
    doAsync: () => Promise<{ url: string }>,
    onError: (error: unknown) => void,
    name: string
): Promise<Window | null> {
    const left = Math.round(window.screen.width / 2 - POPUP_WIDTH / 2);
    const top = Math.round(window.screen.height / 2 - POPUP_HEIGHT / 2);

    // Открываем окно синхронно, чтобы браузер не заблокировал как popup
    const popup = window.open(
        // eslint-disable-next-line no-restricted-syntax -- Здесь необходимо использовать window.open
        '',
        name,
        `width=${POPUP_WIDTH},height=${POPUP_HEIGHT},left=${left},top=${top},resizable=yes,scrollbars=yes`
    );

    if (!popup) {
        showError({ label: 'Открытие модального окна заблокировано политикой браузера.' });

        return null;
    }

    // Поставим простой лоадер, чтобы окно не было «пустым»
    try {
        const doc = popup.document;

        doc.title = `Загрузка${ELLIPSIS}`;

        const style = doc.createElement('style');

        style.textContent =
            'body{font-size:14px;font-family:system-ui;display:grid;place-items:center;height:100vh;margin:0}';
        doc.head.appendChild(style);

        const div = doc.createElement('div');

        div.textContent = 'Готовим данные…';
        doc.body.appendChild(div);
    } catch {
        /* ignore: иногда не успевает записать */
    }

    // Выполняем асинхронное действие и перенаправляем окно
    try {
        const { url } = await doAsync();

        popup.location.replace(url);

        return popup;
    } catch (error) {
        onError(error);
        popup.close();

        return null;
    }
}
